import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import LandingFooter from '@/modules/Pages/shared/LandingFooter';
import LandingNav from '@/modules/Pages/shared/LandingNav';
import '@/modules/Pages/shared/landingPage.css';
import { AppRoutes } from '@/utils/routes/router';

const rows = [
  {
    name: 'churnsignal_consent',
    purpose: 'Remembers whether you allowed analytics cookies or necessary cookies only.',
    duration: 'Kept for 6 months.',
    type: 'Necessary',
  },
  {
    name: 'Sign-in session',
    purpose: 'Keeps you signed in after you log in. These are set by our authentication provider and are not used for advertising.',
    duration: 'Kept for the session, or until you sign out.',
    type: 'Necessary',
  },
  {
    name: 'Cloudflare Turnstile',
    purpose: 'Checks that a waitlist signup is from a person. Set only when that form runs its security check.',
    duration: 'Kept only for the security check.',
    type: 'Necessary',
  },
  {
    name: '_ga, _ga_*, _gid',
    purpose: 'Google Analytics cookies. They recognize a returning browser so we can see which pages are used. Loaded only after you choose Allow all.',
    duration: 'Kept for up to 2 years.',
    type: 'Analytics',
  },
];

export default function CookiePolicyPage() {
  const navigate = useNavigate();
  const goToWaitlist = useCallback(() => {
    navigate(AppRoutes.waitlist);
  }, [navigate]);

  return (
    <div className="landing-page landing-grain min-h-screen font-sans relative">
      <div className="relative z-10">
        <LandingNav onWaitlistClick={goToWaitlist} ctaLabel="Join the waitlist" />
        <main className="px-6 pb-24 pt-32">
          <div className="mx-auto max-w-3xl">
            <p className="landing-section-label mb-4">Privacy</p>
            <h1 className="landing-headline mb-4 text-3xl font-bold md:text-4xl">Cookies</h1>
            <p className="landing-prose mb-10">
              A cookie is a small text file this site stores in your browser and reads on later visits. Necessary
              cookies run the product. Analytics cookies are optional and stay off until you allow them.
            </p>

            <div className="space-y-4">
              {rows.map((row) => (
                <article key={row.name} className="landing-card p-5">
                  <div className="mb-2 flex flex-wrap items-center gap-3">
                    <h2 className="text-base font-semibold text-primary">{row.name}</h2>
                    <span className="text-xs font-semibold uppercase tracking-wide text-accent">{row.type}</span>
                  </div>
                  <p className="text-sm leading-relaxed text-secondary">{row.purpose}</p>
                  <p className="mt-2 text-sm text-muted">{row.duration}</p>
                </article>
              ))}
            </div>

            <p className="mt-10 text-sm leading-relaxed text-secondary">
              Choose Necessary only or Allow all in the banner. You can change that later from Cookie settings in the
              footer. Necessary only still lets you use the site, join the waitlist, and sign in.
            </p>
          </div>
        </main>
        <LandingFooter />
      </div>
    </div>
  );
}
